import { render, staticRenderFns } from "./onlineStudy.vue?vue&type=template&id=7fe2d944&scoped=true&"
import script from "./onlineStudy.vue?vue&type=script&lang=js&"
export * from "./onlineStudy.vue?vue&type=script&lang=js&"
import style0 from "./onlineStudy.vue?vue&type=style&index=0&id=7fe2d944&scoped=true&lang=less&"
import style1 from "./onlineStudy.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe2d944",
  null
  
)

export default component.exports